module.exports = __webpack_public_path__ + "static/media/clouds-sun.b6350459.svg";